import * as React from 'react'
import { FastField } from 'formik'

import { MuiCheckboxFormik } from '@user/components/Formik'
import { SoldServiceAppDataBoolean } from '@user/store/opportunity'

import { useGetCustomFieldProps } from '../hooks'

type Props = {
  disabled: boolean
  appData: SoldServiceAppDataBoolean
}

export function BooleanField(props: Props) {
  const { appData, disabled } = props

  const { fullWidth, ...fieldProps } = useGetCustomFieldProps(appData)

  return (
    <FastField
      {...fieldProps}
      component={MuiCheckboxFormik}
      disabled={disabled}
      color="primary"
      labelProps={{
        style: {
          margin: 'unset',
        },
      }}
    />
  )
}
BooleanField.displayName = 'BooleanField'
